import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import { lighten } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import izicare_logo from '../../../../static/izicare_logo_white.svg';
import { frontaliere_cerise } from '../../../../theme/frontaliere';

export default function FooterFrontaliere() {
  const FooterLink = ({ text }) => (
    <Link href="#" underline="none">
      <Typography
        variant="body2"
        sx={{
          color: 'white',
          fontSize: { xs: '14px', lg: '16px' },
          '&:hover': { opacity: 1 },
        }}
      >
        {text}
      </Typography>
    </Link>
  );
  const buttonStyles = {
    fontFamily: 'JakartaSansMedium !important',
    borderRadius: '50px',
    height: '48px',
    px: 2,
    mx: 0,
    border: '1px solid #87575F',
    color: 'white',
    backgroundColor: lighten(frontaliere_cerise, 0.1),
    fontSize: { xs: '14px', lg: '16px' },
    '&:hover': {
      borderColor: 'white',
      color: 'white',
      backgroundColor: 'rgba(255,255,255,0.1)',
    },
  };
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent={'center'}
      sx={{
        backgroundColor: frontaliere_cerise,
        color: 'white',
        pt: 6,
        pb: 3,
        mt: 'auto',
        px: '20px',
      }}
    >
      <Stack maxWidth="1360px">
        <Grid
          container
          spacing={6}
          justifyContent="space-between"
          alignItems="flex-start"
          sx={{ maxWidth: '1360px' }}
        >
          <Grid item xs={12} md={6} sx={{ mt: 2.5 }}>
            <Box
              component="img"
              src={izicare_logo}
              alt="Logo"
              sx={{ height: '25px', mb: 3 }}
            />

            <Typography
              variant="body1"
              sx={{ opacity: 0.85, color: 'white' }}
            >
              L’assurance santé de référence pour les frontaliers
              affiliés au régime suisse LAMal ou français CMU. Grâce à
              son approche innovante, izi Care permet aux entreprises
              de renforcer leur Marque Employeur et aux frontaliers de
              bénéficier d’une complémentaire santé adaptée à leurs
              besoins.
            </Typography>

            <Button
              variant="outlined"
              sx={{
                fontFamily: 'JakartaSansMedium !important',
                mt: 5,
                borderRadius: '50px',
                height: '48px',
                borderColor: 'white',
                color: 'black !important',
                textTransform: 'none',
                px: 3,
                fontSize: { xs: '14px', lg: '16px' },
                '&:hover': {
                  borderColor: 'white',
                  backgroundColor: 'rgba(255,255,255,0.1)',
                },
              }}
            >
              Besoin d’aide ?
            </Button>
          </Grid>

          <Grid
            item
            xs={12}
            md={6}
            display="flex"
            justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
            sx={{ width: '100%', mt: { lg: 2.5 } }}
          >
            <Stack
              direction={'row'}
              flexWrap="wrap"
              sx={{
                width: '100%',
                gap: 2,
              }}
            >
              <Button sx={buttonStyles}>Espace employeur</Button>
              <Button sx={buttonStyles}>Espace assuré</Button>
              <Button sx={buttonStyles}>Espace partenaire</Button>
            </Stack>
          </Grid>
        </Grid>

        <Grid
          container
          sx={{
            borderTop: '1px solid',
            borderBottom: '1px solid',
            borderColor: '#87575F',
            mt: '50px',
            mb: '20px',
            py: '50px',
            px: 0,
            mx: 0,
            gap: { xs: '40px', md: 0 },
          }}
        >
          <Grid item xs={12} sm={3}>
            <Typography
              variant="body1"
              fontWeight="bold"
              color="white"
              sx={{
                mb: { xs: '14px', lg: '30px' },
              }}
            >
              Les offres izi Care
            </Typography>

            <Stack spacing={1.5}>
              <FooterLink text="Nos contrats individuels" />
              <FooterLink text="Nos contrats collectifs" />
            </Stack>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography
              variant="body1"
              fontWeight="bold"
              color="white"
              sx={{
                mb: { xs: '14px', lg: '30px' },
              }}
            >
              À propos
            </Typography>

            <Stack spacing={1.5}>
              <FooterLink text="Notre guide frontalier" />
              <FooterLink text="Qui sommes-nous ?" />
              <FooterLink text="FAQ" />
              <FooterLink text="Contact" />
            </Stack>
          </Grid>

          <Grid item xs={12} sm={3}>
            <Typography
              variant="body1"
              fontWeight="bold"
              color="white"
              sx={{
                mb: { xs: '14px', lg: '30px' },
              }}
            >
              Légal
            </Typography>

            <Stack spacing={1.5}>
              <FooterLink text="Mentions légales" />
              <FooterLink text="Cookies" />
            </Stack>
          </Grid>
        </Grid>

        <Stack sx={{ itemAlign: 'center', textAlign: 'center' }}>
          <Typography
            variant="body1"
            sx={{
              opacity: 0.8,
              color: 'white',
              textAlign: 'center',
            }}
          >
            {new Date()?.getFullYear()} – izi Care. Tous droits
            réservés
          </Typography>
          <Typography
            variant="body1"
            sx={{
              opacity: 0.8,
              color: 'white',
              textAlign: 'center',
            }}
          >
            izi Care, SAS au capital de EUR 2'000.00 immatriculée 991
            530 817 au R.C.S. Besançon. Siège : 15 Tartre Marin 25500
            Morteau. La distribution des produits d’assurances de la
            marque izi Care est régie par ulteam8 France Sàrl, société
            de courtage en assurance, enregistrée à l’ORIAS sous le
            numéro 16006904. L’assureur et le gestionnaire des
            produits d’assurances de la marque izi Care est La
            Mutuelle La Frontalière, Mutuelle du Livre II du code de
            la mutualité.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
}
